import React from 'react';
import Bugsnag from '@bugsnag/js';
import Layout from '@99designs/apps/spa/common/Layout/Layout';
import { FullscreenError } from '@99designs/layout';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Site } from '@99designs/site-navigation/lib/Site';

interface State {
    error?: Error;
}

interface Props {
    site: Site;
    children?: React.ReactNode;
}

class ErrorBoundary extends React.Component<Props, State> {
    state: State = {};

    componentDidCatch(error: Error) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;

        if (error) {
            Bugsnag.notify(error);

            return (
                // eslint-disable-next-line jsx-a11y/aria-role
                <Layout role="logged-out" site={this.props.site}>
                    <FullscreenError error={error} errorCode="500" />
                </Layout>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
